import Vue from 'vue'

Vue.mixin({
  methods: {
    toastErrorCode(code) {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.toastErrorCode(code)
        }, 50)
        return
      }
      this.$toast.error(this.$t(code))
    },
    toastInfoCode(code) {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.toastInfoCode(code)
        }, 50)
        return
      }
      this.$toast.info(this.$t(code))
    },
    toastError(msg) {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.toastErrorCode(msg)
        }, 50)
        return
      }
      this.$toast.error(msg)
    },
    toastInfo(msg) {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.toastInfoCode(msg)
        }, 50)
        return
      }
      this.$toast.info(msg)
    }
  }
})
